<template>
  <div class="nettdoc-double-dropdown">
    <Dropdown
      :data="data[0]"
      :label="labels[0]"
      :showLabel="showLabels"
      v-on:action="data => $emit('firstAction', data)"
      :choice="firstChoice"
    />

    <Dropdown
      :data="data[1]"
      :label="labels[1]"
      :showLabel="showLabels"
      v-on:action="data => $emit('secondAction', data)"
      :choice="secondChoice"
    />
  </div>
</template>

<script>
import Dropdown from "./Dropdown";
export default {
  name: "DoubleDropdown",
  components: {
    Dropdown
  },
  props: {
    data: Array,
    labels: Array,
    showLabels: Boolean,
    firstChoice: String,
    secondChoice: String
  }
};
</script>

<style lang="scss" scoped>
.nettdoc-double-dropdown {
  display: grid;
  grid-template-columns: 50% 50%;
  position: relative;
  box-sizing: border-box;
  padding: 10px;
}
</style>